import React, { Component } from 'react';
import { GreyButton } from '../../../GreyButton';
import { PrimaryButton } from '../../../PrimaryButton';
import { Modal } from '../../../Modal';
import { Notification } from '../../../Notification';
import './EventLogModal.css';

export interface Props {
  onConfirm(reason: string): void;
  onClose(): void;
}

export interface State {
  reason: string;
}

export class EventLogModal extends Component<Props, State> {
  state = {
    reason: '',
  };

  onTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.persist();
    const { value } = e.target;

    this.setState({ reason: value });
  };

  render() {
    const { onClose, onConfirm } = this.props;
    const { reason } = this.state;

    return (
      <Modal>
        <div className="event-log-modal-overlay">
          <div className="event-log-modal">
            <textarea
              id="reason-input"
              className="event-log-modal__reason-box"
              name="reason"
              placeholder="Enter a reason for resolving incident."
              value={reason}
              onChange={(e) => this.onTextChange(e)}
            />
            <div className="event-log-modal__buttons">
              <div className="event-log-modal__button event-log-modal__button-cancel">
                <GreyButton label="Close" onClick={onClose} fullWidth={true} />
              </div>
              <div className="event-log-modal__button">
                <PrimaryButton label="Resolve" onClick={() => onConfirm(reason)} fullWidth={true} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
